'use strict';
// Native bundle variants own prices, four exact components and shared inventory in Shopify.
// The browser never sets a merchandise price or deducts inventory itself.
// Start the analytics download while the customer reads the PDP, instead of after cart lookup.
const adventStandardEventsReady = import('https://cdn.shopify.com/storefront/standard-events.js').catch(() => null);
window.adventCheckout = async function (items, colorSwitch = null) {
  if (window.ADVENT_CHECKOUT_READY !== true) throw new Error('Der Verkauf ist noch nicht geöffnet.');
  if (window.ADVENT_MARKET?.country !== 'DE' || window.ADVENT_MARKET?.currency !== 'EUR') {
    throw new Error('Dieser Kalender ist nur im deutschen Shop in EUR erhältlich.');
  }
  if (!Array.isArray(items) || !items.length) throw new Error('Bitte prüfe deinen Warenkorb.');
  const map = window.ADVENT_BUNDLES;
  const lines = items.map(item => {
    if (!Array.isArray(item.items) || item.items.length !== 4 || !Number.isSafeInteger(item.qty) || item.qty < 1 || typeof item.group !== 'string' || !item.group) {
      throw new Error('Bitte wähle genau vier Schmuckstücke.');
    }
    const pieces = item.items.map(get);
    if (pieces.some(p => !p || p.needsSize || p.available !== true) || new Set(pieces.map(p => p.family)).size !== 4) {
      throw new Error('Bitte prüfe Verfügbarkeit und Länge deiner vier Schmuckstücke.');
    }
    const key = pieces.map(p => p.variantId).sort().join(',');
    const id = item.type === 'build' ? map.build[key] : map.fixed[item.type]?.key === key ? map.fixed[item.type].variantId : null;
    if (!id) throw new Error('Diese Kombination ist noch nicht verfügbar. Bitte wähle erneut.');
    return {
      id, quantity: item.qty,
      properties: {
        _advent_2026: 'true', _advent_group: item.group,
        ...Object.fromEntries(Object.entries(window.AdventAttribution?.properties?.() || {}).map(([key,value]) => ['_'+key,value])),
        _Kalender: labels[item.type],
        _Verpackung: '4 schwarze Schmuckboxen mit Schleifen · Unterseite 1–4',
        ...Object.fromEntries(pieces.map((p, i) => ['_Advent ' + (i + 1), p.name + ' · ' + p.sku + (p.baseId ? ' · ' + p.size : '')]))
      }
    };
  });
  if (window.ADVENT_CART_DRAWER_MODE === true) {
    if (!window.adventAddToNativeCart) throw new Error('Der Warenkorb ist noch nicht bereit. Lade die Seite neu.');
  const utm = new URLSearchParams();
  try {
    const stored = new URLSearchParams(sessionStorage.getItem('advent-v2-utm') || '');
    const currentQuery = new URLSearchParams(location.search);
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
      const value = currentQuery.get(key) || stored.get(key);
      if (value) utm.set(key, value.slice(0, 240));
    }
  } catch (_) { /* Checkout still works if storage is disabled. */ }
  const attributes = {
      Adventskalender: '2026', ...window.AdventAttribution?.properties?.(),
      ...(/^(gold>silver|silver>gold)$/.test(colorSwitch || '') ? {advent_color_switch: colorSwitch} : {}),
      'Advent pakning': '4 smykkeæsker med sorte bånd pr. kalender. Nummerér under bunden 1–4 efter Advent-felterne på kalenderlinjen.',
      ...Object.fromEntries([...utm].map(([key, value]) => ['advent_' + key, value]))
  };
    return window.adventAddToNativeCart(lines, attributes);
  }
  let current = window.adventTakeCartSnapshot?.();
  if (!current) {
    const cartResponse = await fetch('/cart.js', {headers: {Accept: 'application/json'}});
    if (!cartResponse.ok) throw new Error('Der Warenkorb ist gerade nicht erreichbar. Bitte versuche es erneut.');
    current = await cartResponse.json();
  }
  // Retrying after a lost response must not add the same calendar twice.
  const updates = {};
  // The Advent selection is authoritative for Advent lines; ordinary shop items stay untouched.
  // This also reconciles a calendar removed after returning from checkout.
  for (const existing of current.items) {
    if ((existing.properties?._advent_2026 === 'true' || existing.properties?._advent_gift_card === 'true') && existing.properties?._advent_group &&
        !lines.some(line => String(existing.variant_id) === String(line.id) && existing.properties._advent_group === line.properties._advent_group)) {
      updates[existing.key] = 0;
    }
  }
  const missing = lines.filter(line => {
    const existing = current.items.find(existing => String(existing.variant_id) === String(line.id) && existing.properties?._advent_group === line.properties._advent_group);
    if (existing && existing.quantity !== line.quantity) updates[existing.key] = line.quantity;
    return !existing;
  });
  // Preserve the original landing attribution through AJAX cart and checkout.
  const utm = new URLSearchParams();
  try {
    const stored = new URLSearchParams(sessionStorage.getItem('advent-v2-utm') || '');
    const currentQuery = new URLSearchParams(location.search);
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
      const value = currentQuery.get(key) || stored.get(key);
      if (value) utm.set(key, value.slice(0, 240));
    }
  } catch (_) { /* Checkout still works if storage is disabled. */ }
  // Shopify's standard storefront cart event lets app listeners observe this custom AJAX path.
  // It is distinct from the Web Pixels standard event and must be verified in unpublished-theme QA.
  let cartEvent = null;
  const prepareCartEvent = async () => {
    if (!missing.length) return;
    try {
      let sdkTimeoutId;
      const events = await Promise.race([
        adventStandardEventsReady,
        new Promise(resolve => { sdkTimeoutId = setTimeout(() => resolve(null), 500); })
      ]).finally(() => clearTimeout(sdkTimeoutId));
      const {CartLinesUpdateEvent, CartErrorEvent} = events;
      const deferred = CartLinesUpdateEvent.createPromise();
      const target = document.body;
      target.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'page',
        lines: missing.map(line => ({merchandiseId: String(line.id), quantity: line.quantity})),
        promise: deferred.promise
      }));
      cartEvent = {CartLinesUpdateEvent, CartErrorEvent, deferred, target};
    } catch (_) { /* An analytics library outage must not block checkout. */ }
  };
  const cartEventReady = prepareCartEvent();
  try {
  if (missing.length) {
    const response = await fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: missing})
    });
    if (!response.ok) {
      if (response.status === 422) throw new Error('Mindestens ein Schmuckstück ist nicht mehr in der gewünschten Menge verfügbar. Bitte passe deine Auswahl an.');
      throw new Error('Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
    }
  }
  // Order attributes expose the packing requirement without replacing the customer's note.
  const attributes = {
      Adventskalender: '2026', ...window.AdventAttribution?.properties?.(),
      ...(/^(gold>silver|silver>gold)$/.test(colorSwitch || '') ? {advent_color_switch: colorSwitch} : {}),
      'Advent pakning': '4 smykkeæsker med sorte bånd pr. kalender. Nummerér under bunden 1–4 efter Advent-felterne på kalenderlinjen.',
      ...Object.fromEntries([...utm].map(([key, value]) => ['advent_' + key, value]))
  };
  // An unchanged, already prepared calendar needs no second cart write.
  // After an add we still obtain the authoritative full cart for the pixel event.
  const needsUpdate = missing.length || Object.keys(updates).length ||
    Object.entries(attributes).some(([key, value]) => current.attributes?.[key] !== value);
  const marked = needsUpdate ? await fetch('/cart/update.js', {
    method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    body: JSON.stringify({updates, attributes})
  }) : {ok: true};
  if (!marked.ok) throw new Error('Dein Kalender liegt im Warenkorb. Die Verpackungsangabe konnte noch nicht gespeichert werden – bitte erneut versuchen.');
  await cartEventReady;
  if (cartEvent) {
    try {
      const ajaxCart = await marked.json();
      cartEvent.deferred.resolve({cart: cartEvent.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart)});
    } catch (_) { cartEvent.deferred.resolve({cart: null}); }
  }
  // Shopify published one product_added_to_cart event and Stape's app pixel
  // consumed it in dev-theme QA. Sending fbq here would risk a second Meta event.
  location.assign('/checkout' + (utm.size ? '?' + utm.toString() : ''));
  } catch (error) {
    await cartEventReady;
    if (cartEvent) {
      cartEvent.target.dispatchEvent(new cartEvent.CartErrorEvent({error: error.message, code: 'SERVICE_UNAVAILABLE'}));
      cartEvent.deferred.reject(error);
    }
    throw error;
  }
};
